import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import lv from './locales/lv/translation.json';
import en from './locales/en/translation.json';
import ru from './locales/ru/translation.json';


i18n
  .use(initReactI18next)
  .init({
    resources: {
      lv: { translation: lv },
      en: { translation: en },
      ru: { translation: ru}
    },
    fallbackLng: 'lv',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
